import {
	Component,
	Input,
	Output,
	EventEmitter,
	ChangeDetectionStrategy
} from '@angular/core';
import {ACTION_IDS} from '../../models/data-table.models';
import {Action} from 'src/app/models/layout';

/**
 * Renders action buttons for a single row in the data table.
 * Uses OnPush change detection for performance.
 */
@Component({
	selector: 'data-table-row-actions',
	templateUrl: './data-table-row-actions.component.html',
	styleUrls: ['./data-table-row-actions.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class DataTableRowActionsComponent
{
	@Input() row: any;
	@Input() rowIndex!: number;
	@Input() isEditing = false;
	@Input() isCanceled = false;
	@Input() isDeleted = false;
	@Input() isNewRow = false;

	// Available actions (pre-computed by parent)
	@Input() availableActions: Set<string> = new Set();

	// Disabled actions
	@Input() isDeleteDisabled = false;

	@Input() customActions: Action[] | null = null;

	@Output() action = new EventEmitter<{ action: string; rowIndex: number; row?: any }>();

	readonly ACTION_IDS = ACTION_IDS;

	hasAction(actionId: string): boolean
	{
		return this.availableActions.has(actionId);
	}

	canDelete(): boolean
	{
		return !this.row?.STATUS || this.row?.STATUS === 'CANCELLED';
	}

	emitAction(actionId: string): void
	{
		this.action.emit({action: actionId, rowIndex: this.rowIndex, row: this.row});
	}
}
